import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiLogOut } from 'react-icons/fi';
import { useAuth } from '../../context/AuthContext';

const StudentNav = () => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    return (
        <nav style={{
            height: isMobile ? 54 : 66,
            background: 'rgba(237,250,244,0.97)',
            backdropFilter: 'blur(20px)',
            WebkitBackdropFilter: 'blur(20px)',
            borderBottom: '1px solid rgba(39,160,101,0.15)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: isMobile ? '0 14px' : '0 28px',
            position: 'sticky',
            top: 0,
            zIndex: 50,
            boxShadow: '0 2px 14px rgba(39,160,101,0.08)',
        }}>
            {/* Left: Logo + Title */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                {isMobile && (
                    <img src="/svu-logo.png" alt="SVU" style={{ width: 26, height: 26, borderRadius: 7, objectFit: 'cover' }} />
                )}
                <h2 style={{
                    fontSize: isMobile ? 15 : 19,
                    fontWeight: 800,
                    color: '#1a3326',
                    fontFamily: 'Outfit, sans-serif',
                    margin: 0,
                    letterSpacing: -0.3,
                }}>Exam Panel</h2>
            </div>

            {/* Right: User pill + Logout */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>

                {/* User pill */}
                <div style={{
                    display: 'flex', alignItems: 'center', gap: 9,
                    padding: '5px 14px 5px 5px',
                    borderRadius: 50,
                    background: 'rgba(39,160,101,0.08)',
                    border: '1.5px solid rgba(39,160,101,0.18)',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                }} onClick={() => navigate('/student/profile')}
                    title="View Profile"
                >
                    <div style={{
                        width: 32, height: 32, borderRadius: '50%',
                        background: 'linear-gradient(135deg, #6edba8, #27a065)',
                        color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
                        fontSize: 14, fontWeight: 800,
                        boxShadow: '0 2px 8px rgba(39,160,101,0.28)',
                        flexShrink: 0,
                    }}>
                        {user?.name?.charAt(0)?.toUpperCase() || 'S'}
                    </div>
                    {!isMobile && (
                        <div>
                            <div style={{ fontSize: 13, fontWeight: 700, color: '#1a3326', lineHeight: 1.2 }}>
                                {user?.name || 'Student'}
                            </div>
                            <div style={{ fontSize: 10, fontWeight: 700, color: '#27a065', textTransform: 'uppercase', letterSpacing: 0.6 }}>
                                Student
                            </div>
                        </div>
                    )}
                </div>

                {/* Logout button */}
                <button
                    onClick={handleLogout}
                    title="Logout"
                    style={{
                        display: 'flex', alignItems: 'center', gap: isMobile ? 0 : 6,
                        padding: isMobile ? '8px' : '8px 14px',
                        borderRadius: 10,
                        border: '1.5px solid rgba(220,96,96,0.25)',
                        background: 'rgba(239,68,68,0.06)',
                        color: '#c05050',
                        fontSize: 13, fontWeight: 700,
                        fontFamily: 'Outfit, sans-serif',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        whiteSpace: 'nowrap',
                    }}
                    onMouseEnter={e => {
                        e.currentTarget.style.background = 'rgba(239,68,68,0.12)';
                        e.currentTarget.style.borderColor = 'rgba(220,96,96,0.45)';
                    }}
                    onMouseLeave={e => {
                        e.currentTarget.style.background = 'rgba(239,68,68,0.06)';
                        e.currentTarget.style.borderColor = 'rgba(220,96,96,0.25)';
                    }}
                >
                    <FiLogOut size={15} />
                    {!isMobile && <span>Logout</span>}
                </button>
            </div>
        </nav>
    );
};

export default StudentNav;
